(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ShowcaseLayoutTemplateDetailController', ShowcaseLayoutTemplateDetailController);

    ShowcaseLayoutTemplateDetailController.$inject = [
        '$state',
        '$stateParams',
        '$translate',
        '$uibModal',
        'ShowcaseLayoutTemplateService',
        'FlyerCategoryService',
        'toastr',
        'ModalFactory'
    ];

    function ShowcaseLayoutTemplateDetailController(
        $state,
        $stateParams,
        $translate,
        $uibModal,
        ShowcaseLayoutTemplateService,
        FlyerCategoryService,
        toastr,
        ModalFactory
    ) {
        var vm = this;
        var COLUMN_OPTIONS = [1, 2, 3, 4];

        vm.isLoading = true;
        vm.isSaving = false;
        vm.templateId = $stateParams.templateId ? parseInt($stateParams.templateId, 10) : null;
        vm.isEdit = !!vm.templateId;
        vm.columnOptions = COLUMN_OPTIONS;

        vm.template = {
            name: '',
            description: ''
        };

        vm.rows = [];
        vm.viewComponentCatalog = [];
        vm.categories = [];

        vm.$onInit = init;
        vm.goBack = goBack;
        vm.save = save;
        vm.insertRow = insertRow;
        vm.removeRow = removeRow;
        vm.moveRow = moveRow;
        vm.setColumnCount = setColumnCount;
        vm.canSetColumnCount = canSetColumnCount;
        vm.openComponentPicker = openComponentPicker;
        vm.openComponentEditor = openComponentEditor;
        vm.removeComponent = removeComponent;
        vm.removeSlot = removeSlot;
        vm.moveSlot = moveSlot;

        function init() {
            loadCategories();
            ShowcaseLayoutTemplateService.getViewComponents().then(function (catalog) {
                vm.viewComponentCatalog = catalog || [];
                if (vm.isEdit) {
                    loadTemplate();
                } else {
                    vm.isLoading = false;
                }
            }, function () {
                toastr.error($translate.instant('showcase-layout-template.messages.load.error'));
                vm.isLoading = false;
            });
        }

        function loadCategories() {
            FlyerCategoryService.listCategoriesByCurrentStore($translate.use()).then(function (response) {
                var categories = response.data || response || [];
                vm.categories = categories.map(function (category) {
                    return {
                        key: category.key,
                        title: category.title || category.key
                    };
                });
            }, function () {
                vm.categories = [];
            });
        }

        function loadTemplate() {
            ShowcaseLayoutTemplateService.get(vm.templateId).then(function (template) {
                vm.template.name = template.name;
                vm.template.description = template.description || '';
                vm.template.status = template.status;
                vm.template.hasAssociatedShowcases = !!template.hasAssociatedShowcases;
                vm.rows = mapRowsFromApi(template.rows || []);
                vm.isLoading = false;
            }, function () {
                toastr.error($translate.instant('showcase-layout-template.messages.load.error'));
                vm.isLoading = false;
            });
        }

        function mapRowsFromApi(apiRows) {
            return apiRows.map(function (apiRow, index) {
                var columnCount = apiRow.columnCount || 1;
                return {
                    id: apiRow.id || null,
                    position: apiRow.position || (index + 1),
                    columnCount: columnCount,
                    slots: buildSlots(columnCount, apiRow.slots || [])
                };
            });
        }

        function buildSlots(columnCount, apiSlots) {
            var slots = [];
            var i;
            for (i = 0; i < columnCount; i++) {
                slots.push({
                    columnIndex: i,
                    component: mapSlotComponent(findApiSlot(apiSlots, i))
                });
            }
            return slots;
        }

        function findApiSlot(apiSlots, columnIndex) {
            return (apiSlots || []).find(function (slot) {
                return slot.columnIndex === columnIndex;
            });
        }

        function mapSlotComponent(apiSlot) {
            if (!apiSlot || !apiSlot.component) {
                return null;
            }
            return mapComponentFromApi(apiSlot.component);
        }

        function mapComponentFromApi(component) {
            var viewComponent = component.viewComponent || {};
            var parsedValue = parseValue(component.value);
            if (!parsedValue && component.bannerIds && component.bannerIds.length) {
                parsedValue = { bannerIds: component.bannerIds.slice() };
            }
            return {
                id: component.id,
                title: component.title,
                viewComponentId: viewComponent.id || component.viewComponentId,
                componentKey: viewComponent.key || component.componentKey,
                value: component.value,
                parsedValue: parsedValue,
                banners: component.banners || []
            };
        }

        function parseValue(value) {
            if (!value) {
                return null;
            }
            try {
                return angular.fromJson(value);
            } catch (e) {
                return null;
            }
        }

        function insertRow() {
            vm.rows.push(createEmptyRow(1));
            reindexRows();
        }

        function createEmptyRow(columnCount) {
            return {
                id: null,
                position: vm.rows.length + 1,
                columnCount: columnCount,
                slots: buildSlots(columnCount, [])
            };
        }

        function removeRow(row) {
            var index = vm.rows.indexOf(row);
            if (index === -1) {
                return;
            }
            vm.rows.splice(index, 1);
            reindexRows();
        }

        function moveRow(row, direction) {
            var index = vm.rows.indexOf(row);
            var target = index + direction;
            if (index === -1 || target < 0 || target >= vm.rows.length) {
                return;
            }
            vm.rows.splice(index, 1);
            vm.rows.splice(target, 0, row);
            reindexRows();
        }

        function setColumnCount(row, columnCount) {
            if (!canSetColumnCount(row, columnCount)) {
                toastr.warning($translate.instant('showcase-layout-template.builder.cannotReduceColumns'));
                return;
            }
            var slots = row.slots.slice(0, columnCount);
            while (slots.length < columnCount) {
                slots.push({ columnIndex: slots.length, component: null });
            }
            slots.forEach(function (slot, index) {
                slot.columnIndex = index;
            });
            row.columnCount = columnCount;
            row.slots = slots;
        }

        function canSetColumnCount(row, columnCount) {
            if (columnCount >= row.columnCount) {
                return true;
            }
            return row.slots.slice(columnCount).every(function (slot) {
                return !slot.component;
            });
        }

        function reindexRows() {
            vm.rows.forEach(function (row, index) {
                row.position = index + 1;
            });
        }

        function openComponentPicker(row, slot) {
            openComponentModal(row, slot, null);
        }

        function openComponentEditor(row, slot) {
            if (!slot.component) {
                return;
            }
            openComponentModal(row, slot, slot.component);
        }

        function openComponentModal(row, slot, editingComponent) {
            $uibModal.open({
                templateUrl: 'app/admin/showcase-layout-template/modal/layout-template-component-modal.html',
                controller: 'LayoutTemplateComponentModalController',
                controllerAs: 'vm',
                windowClass: 'side-modal',
                backdrop: 'static',
                resolve: {
                    modalData: function () {
                        return {
                            rowNumber: row.position,
                            columnNumber: slot.columnIndex + 1,
                            viewComponentCatalog: vm.viewComponentCatalog,
                            editingComponent: editingComponent
                        };
                    }
                }
            }).result.then(function (resultComponent) {
                if (!resultComponent) {
                    return;
                }
                slot.component = {
                    id: resultComponent.id || (editingComponent && editingComponent.id) || null,
                    title: resultComponent.title,
                    viewComponentId: resultComponent.viewComponentId,
                    componentKey: resultComponent.componentKey,
                    parsedValue: resultComponent.parsedValue,
                    value: buildComponentValue(resultComponent),
                    banners: resultComponent.previewBanners || []
                };
            });
        }

        function removeComponent(row, slot) {
            slot.component = null;
        }

        function removeSlot(row, slot) {
            if (!row || row.columnCount <= 1) {
                return;
            }
            var index = row.slots.indexOf(slot);
            if (index === -1) {
                return;
            }
            row.slots.splice(index, 1);
            row.columnCount = row.slots.length;
            row.slots.forEach(function (remaining, columnIndex) {
                remaining.columnIndex = columnIndex;
            });
        }

        function moveSlot(row, slot, direction) {
            if (!row || !slot || !direction) {
                return;
            }
            var index = row.slots.indexOf(slot);
            var target = index + direction;
            if (index === -1 || target < 0 || target >= row.slots.length) {
                return;
            }
            var currentComponent = row.slots[index].component;
            row.slots[index].component = row.slots[target].component;
            row.slots[target].component = currentComponent;
        }

        function save() {
            if (!vm.template.name || !vm.template.name.trim()) {
                toastr.warning($translate.instant('showcase-layout-template.messages.name.required'));
                return;
            }

            if (!vm.rows.length) {
                toastr.warning($translate.instant('showcase-layout-template.messages.rows.required'));
                return;
            }

            var saveAction = function () {
                vm.isSaving = true;
                var payload = buildPayload();

                var request = vm.isEdit
                    ? ShowcaseLayoutTemplateService.update(vm.templateId, payload)
                    : ShowcaseLayoutTemplateService.create(payload);

                request.then(function () {
                    vm.isSaving = false;
                    toastr.success($translate.instant('showcase-layout-template.messages.save.success'));
                    $state.go('showcase-layout-templates');
                }, function () {
                    vm.isSaving = false;
                    toastr.error($translate.instant('showcase-layout-template.messages.save.error'));
                });
            };

            if (vm.isEdit && vm.template.hasAssociatedShowcases) {
                ModalFactory.openWarningModal(
                    $translate.instant('showcase-layout-template.messages.edit.confirm.title'),
                    $translate.instant('showcase-layout-template.messages.edit.confirm.subtitle'),
                    $translate.instant('showcase-layout-template.messages.edit.confirm.small-text'),
                    null,
                    $translate.instant('showcase-layout-template.messages.edit.confirm.confirm-button'),
                    $translate.instant('entity.action.cancel'),
                    saveAction
                );
                return;
            }

            saveAction();
        }

        function buildPayload() {
            return {
                name: vm.template.name.trim(),
                description: vm.template.description,
                rows: vm.rows.map(function (row, rowIndex) {
                    return {
                        id: row.id || null,
                        position: rowIndex + 1,
                        columnCount: row.columnCount,
                        slots: row.slots.map(function (slot) {
                            return {
                                columnIndex: slot.columnIndex,
                                component: slot.component ? {
                                    id: slot.component.id || null,
                                    title: slot.component.title,
                                    viewComponentId: slot.component.viewComponentId,
                                    value: buildComponentValue(slot.component)
                                } : null
                            };
                        })
                    };
                })
            };
        }

        function buildComponentValue(component) {
            var catalogItem = vm.viewComponentCatalog.find(function (item) {
                return item.id === component.viewComponentId;
            });

            if (!catalogItem || !catalogItem.hasValue) {
                return null;
            }

            var value = component.parsedValue || {};
            return angular.toJson(value);
        }

        function goBack() {
            $state.go('showcase-layout-templates');
        }
    }

})();
